function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 4.75H3a1.502 1.502 0 00-1.5 1.5V8.5A1.502 1.502 0 003 10v8.25a1.502 1.502 0 001.5 1.5h15a1.502 1.502 0 001.5-1.5V10a1.502 1.502 0 001.5-1.5V6.25a1.502 1.502 0 00-1.5-1.5zm-6.75 9h-4.5a.75.75 0 110-1.5h4.5a.75.75 0 110 1.5zM21 8.5H3V6.25h18V8.5z",
    fill: props.fill
  }));
}

export default SvgArchive;